module.exports = new __parcel__URL__("pdf.worker.min.766932e3.js").toString();